var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.793 1.3335H5.20634C2.77967 1.3335 1.33301 2.78016 1.33301 5.20683V10.7868C1.33301 13.2202 2.77967 14.6668 5.20634 14.6668H10.7863C13.213 14.6668 14.6597 13.2202 14.6597 10.7935V5.20683C14.6663 2.78016 13.2197 1.3335 10.793 1.3335ZM11.5063 6.64016L9.96634 8.62683C9.77301 8.8735 9.49967 9.0335 9.18634 9.06683C8.87301 9.10683 8.56634 9.02016 8.31967 8.82683L7.09967 7.86683C7.05301 7.82683 6.99967 7.82683 6.97301 7.8335C6.94634 7.8335 6.89967 7.84683 6.85967 7.90016L5.27301 9.96016C5.17301 10.0868 5.02634 10.1535 4.87967 10.1535C4.77301 10.1535 4.66634 10.1202 4.57301 10.0468C4.35301 9.88016 4.31301 9.56683 4.47967 9.34683L6.06634 7.28683C6.25968 7.04016 6.53301 6.88016 6.84634 6.84016C7.15301 6.80016 7.46634 6.88683 7.71301 7.08016L8.93301 8.04016C8.97967 8.08016 9.02634 8.08016 9.05967 8.0735C9.08634 8.0735 9.13301 8.06016 9.17301 8.00683L10.713 6.02016C10.8797 5.80016 11.1997 5.76016 11.413 5.9335C11.633 6.1135 11.673 6.42683 11.5063 6.64016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.dd9da812fc28ef98b55ed61ef0aa5eaa.svg";
export { ForwardRef as ReactComponent };